






























import { Component, Prop } from "vue-property-decorator";
import { MarkdownConfiguration } from "./markdownConfiguration";
import WidgetBase from "../WidgetBase.vue";
import VueMarkdownEditor from "@kangc/v-md-editor";
import { FileService } from "../../../services/fileService";

@Component({ components: { "v-md-editor": VueMarkdownEditor } })
export default class MarkdownWidget extends WidgetBase<MarkdownConfiguration> {
    @Prop() widgetHeight!: number;

    public rightToolbar: string = "preview toc sync-scroll";
    public preview: boolean = false;

    public static get type() {
        return "markdown";
    }

    public static get thumbnailAsset() {
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        return require("@/assets/widget-thumbnails/markdown.svg");
    }

    public mounted() {
        if (!this.config.state?.text) {
            this.text = this.$t("widget.markdown.instruction").toString();
        }
    }

    public get text(): string {
        return this.config.state.text;
    }

    public set text(newText: string) {
        this.config.state.text = newText;
    }

    public get isPresenter(): boolean {
        if (!this.$store.state.studio && this.$store.state.user) {
            return true;
        } else {
            return this.$store.getters.isPresenter;
        }
    }

    public get editorHeight() {
        return `${this.widgetHeight - 46}px`;
    }

    public get editEnabled(): string {
        if (this.preview) {
            return "preview";
        } else if (this.isPresenter || this.allowEdit) {
            return "editable";
        } else {
            return "preview";
        }
    }
    public get uploadUrl(): string {
        return "/api/file/by_id/" + this.config.widgetId;
    }

    public get allowEdit(): boolean {
        return this.config.state.allowEdit;
    }

    public set allowEdit(newVal: boolean) {
        this.config.state.allowEdit = newVal;
        this.update({
            config: this.config,
            payload: { text: this.text, allowEdit: newVal },
        });
    }

    public saveHandler() {
        this.update({
            config: this.config,
            payload: { text: this.text, allowEdit: this.allowEdit },
        });
        this.$store.commit("showSnackbar", {
            text: this.$t("widget.markdown.saved"),
            color: "success",
        });
    }

    public handleUploadImage(
        event: Event,
        insertImage: Function,
        files: File[]
    ) {
        FileService.uploadFile(this.config.widgetId, files[0]).then(
            response => {
                insertImage({
                    url: `/api/file/by_id/${response.data.id}`,
                    desc: response.data.filename,
                    width: "300",
                    height: "300",
                });
            }
        );
    }
}
